import React, { Component } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash.isempty';
import qs from 'querystring';

import './stylesheets/main.scss';
import Tabs from './components/findActivities/Tabs';
import SearchBar from './components/findActivities/SearchBar';
import FilterList from './components/findActivities/FilterList';
import ActivityList from './components/findActivities/ActivityList';
import AddActivity from './components/findActivities/AddActivity';
import MediaQuery from 'react-responsive';
import NoResults from "./components/findActivities/Activities/NoResults";

import { searchActivities, setSearchValue } from './actions/findActivities/search/get';
import { setDisplayType } from './actions/display/update';
import { toggleFilter } from './actions/findActivities/filters/selected';

class App extends Component
{

    constructor(props) {
        super(props);

        this.state = {
            queryText     : '',
            view          : this.props.displayType,
            selectedTab   : 0,
            isModalOpen   : false,
            listCurrentPage: this.props.searchValues.page || 1,
        }
    }

    componentWillMount() {
        if(window.location.search) {
            const searchString = window.location.search.substring(1);
            const obj = qs.parse(searchString);

            // reset the tav view
            if(obj.tabView) {
                this.setState({
                    view: obj.tabView
                });
                this.props.setDisplayType(obj.tabView);
            }

            if(obj.page) {
                this.setState({ listCurrentPage: obj.page });
                this.props.setSearchValue('page', obj.page );
            }

            ['activity','address','radius','latitude','longitude'].forEach(k => {
                if(typeof obj[k] !== 'undefined') this.props.setSearchValue(k, obj[k]);
            });

            const togFilt = this.props.toggleFilter;

            Object.keys(obj).forEach(function(key) {
                if(key.indexOf('filters') !== -1) {
                    let idxStr = key.replace('filters[','');
                    const idx = idxStr.split("[").map(x => x.replace(']',''));
                    const value = obj[key];
                    togFilt(idx[0], value);
                }
            });

            // set the selected filters
            setTimeout(() => {
                this.props.searchActivities(this.props.searchValues, this.props.selectedFilters, obj.tabView === 'map', (obj.tabView === 'map' ? null : obj.page), obj.tabView);
            },100);
        } else {
            this.props.setDisplayType(this.state.view);
            this.props.searchActivities(this.props.searchValues, this.props.selectedFilters, true, null, 'map');
        }
    }

    toggleResultsView = (value) => {
        this.setState({ view: value });
        this.props.setDisplayType(value);
        
        if (value === 'list') { this.props.setSearchValue('limit', ''); }
        if (value === 'map') { this.setState({ listCurrentPage: this.props.searchValues.page }); }

        this.props.searchActivities(this.props.searchValues, this.props.selectedFilters, value === 'map', (value === 'map' ? null : this.state.listCurrentPage), value);
    }

    setListCurrentPage = (page) => {
        this.setState({ listCurrentPage: page });
        this.props.setSearchValue('page', page);
    }

    toggleTabs = (value) => {
        this.setState({ selectedTab: value});
    }

    openModal = () => {
        document.body.classList.add('modalopen');
        this.setState({ isModalOpen: true });
    }

    closeModal = () => {
        document.body.classList.remove('modalopen');
        this.setState({ isModalOpen: false });
    }

    render() {
        const { selectedTab, isModalOpen } = this.state;
        const { results } = this.props;

        return (
            <div className="App">
                <Tabs onTabClick={this.toggleTabs} />
                <SearchBar selectedTab={selectedTab} modalControllerClick={this.openModal} showFilter={results.length !== 0} setListCurrentPage={this.setListCurrentPage} />
                {<div className="content-layout content-layout__wide content-layout_collapse main-container">
                    <div className="large-wrap">
                        <div className="side-main">
                            <MediaQuery minWidth={768}>
                                {(matches) => (
                                    <div className={matches ? 'side-col' : ''}>
                                        <FilterList
                                            classes={this.state.view === 'map' && 'white-bg'}
                                            searchActivities={this.searchActivities}
                                            queryText={this.state.queryText}
                                            isModalOpen={isModalOpen}
                                            closeModal={this.closeModal}
                                            setListCurrentPage={this.setListCurrentPage}
                                        />
                                    </div>
                                )}
                            </MediaQuery>
                            <div className="main-col">
                                {results.length === 0
                                    ? <NoResults address={this.props.searchValues.address} classes={this.state.view === 'map' && 'extra-padding'} />
                                    : <ActivityList onTabClick={this.toggleResultsView} address={this.props.searchValues.address} setListCurrentPage={this.setListCurrentPage} listCurrentPage={this.state.listCurrentPage} />
                                }
                            </div>
                        </div>
                    </div>
                </div>}
                <AddActivity />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    results: state.searchActivities,
    selectedFilters: state.selectedFilters,
    searchValues: state.searchValues ? state.searchValues : {},
    displayType: !isEmpty(state.displayType) ? state.displayType : 'map',
});

const mapDispatchToProps = dispatch => ({
    searchActivities: (values, filters, limit, page, tabView) => {
        dispatch(searchActivities(values, filters, limit, page, tabView));
    },
    setSearchValue: (k,v) => {
        dispatch(setSearchValue(k,v));
    },
    setDisplayType: (viewType) => {
        dispatch(setDisplayType(viewType));
    },
    toggleFilter: (id, value) => {
        dispatch(toggleFilter(id, value));
    }
});

export default connect(mapStateToProps, mapDispatchToProps) (App);
